export type ThemePreference = 'light' | 'dark';

const STORAGE_KEY = 'gs_theme';

export function getStoredTheme(): ThemePreference | null {
  try {
    const value = localStorage.getItem(STORAGE_KEY);
    if (value === 'light' || value === 'dark') return value;
  } catch {
    /* ignore */
  }
  return null;
}

export function getSystemTheme(): ThemePreference {
  if (typeof window === 'undefined') return 'light';
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

export function resolveTheme(preference: ThemePreference | null): ThemePreference {
  // Product default is light so operators get readable contrast out of the box.
  return preference ?? 'light';
}

/** Apply theme the same way the design HTML does: data-theme on the root. */
export function applyThemeClass(theme: ThemePreference): void {
  const root = document.documentElement;
  root.setAttribute('data-theme', theme);
  root.classList.toggle('dark', theme === 'dark');
  root.style.colorScheme = theme;
}

export function persistTheme(theme: ThemePreference): void {
  try {
    localStorage.setItem(STORAGE_KEY, theme);
  } catch {
    /* ignore */
  }
}
